import { HttpClient, HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, Subject, takeUntil, tap, throwError } from 'rxjs';
import { environment as env } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

     // Observable para cancelar todas las peticiones pendientes
	public ngUnsubscribe = new Subject<void>();
	ngUnsubscribe$ = this.ngUnsubscribe.asObservable();

  constructor(private http: HttpClient) { }

  cancelAllHttpRequest() {
    this.ngUnsubscribe.next();
  }

  _get(url: string, params: any, onlyUrl = false, alert = true): Observable<any> {
    const alertHeader: string = String(alert);
    return this.http.get(`${!onlyUrl ? env.url : ''}${url}`, { params: params, headers: { 'skip': 'true', 'type-require-alert': alertHeader } }).pipe(
      tap((resp: any) => {
        // Manejar la respuesta
      }),
      takeUntil(this.ngUnsubscribe),
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error);
      })
    );
  }


  _post(url: string, data: any, alert = true): Observable<any> {
    const alertHeader: string = String(alert);
    return this.http.post(`${env.url}${url}`, data, { headers: { 'skip': 'true', 'type-require-alert': alertHeader } }).pipe(
      tap((resp: any) => {
        // Manejar la respuesta
      }),
      takeUntil(this.ngUnsubscribe),
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error);
      })
    );
  }


}
